import { collection, getDocs, getFirestore } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { DBCollection } from '@/lib/utils/constants-shared';

/**
 * Fetch all archaeology by book data from Firestore
 */
export async function fetchArchaeologyByBookFromDB(): Promise<ArchaeologyByBook[]> {
  const db = getFirestore(getApp());
  const archaeologyByBookCollection = collection(db, DBCollection.archaeologyByBook);
  const snapshot = await getDocs(archaeologyByBookCollection);

  return snapshot.docs.map(doc => {
    const data = doc.data() as FirebaseArchaeologyByBook<any>;
    return {
      ...data,
      dateCreated: data.dateCreated.toDate(),
      dateUpdated: data.dateUpdated.toDate()
    } as ArchaeologyByBook;
  });
}

